import { Undo2, Redo2 } from 'lucide-react';
import { Button } from './ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from './ui/tooltip';
import { useUndoContext } from '../contexts/UndoContext';
import { useI18n } from '../i18n';

/**
 * Undo/Redo кнопки для toolbar канваса.
 * Отображают tooltip с описанием последнего действия и shortcut hint.
 * Disabled при пустом стеке.
 */
export default function UndoRedoButtons() {
  const { undo, redo, canUndo, canRedo, undoDescription, redoDescription } =
    useUndoContext();
  const { t } = useI18n();

  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            className="tool-btn"
            disabled={!canUndo}
            onClick={undo}
            // Named with its shortcut, as the tooltip: a bare «Undo» is the
            // letopis world time's undo (the two are on screen together).
            aria-label={
              undoDescription
                ? `${t('toolbar.undo')}: ${undoDescription}`
                : `${t('toolbar.undo')} (Ctrl+Z)`
            }
            data-testid="toolbar-btn-undo"
          >
            <Undo2 size={16} />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          {undoDescription
            ? `${t('toolbar.undo')}: ${undoDescription} (Ctrl+Z)`
            : `${t('toolbar.undo')} (Ctrl+Z)`}
        </TooltipContent>
      </Tooltip>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            className="tool-btn"
            disabled={!canRedo}
            onClick={redo}
            aria-label={
              redoDescription
                ? `${t('toolbar.redo')}: ${redoDescription}`
                : t('toolbar.redo')
            }
            data-testid="toolbar-btn-redo"
          >
            <Redo2 size={16} />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          {redoDescription
            ? `${t('toolbar.redo')}: ${redoDescription} (Ctrl+Shift+Z)`
            : `${t('toolbar.redo')} (Ctrl+Shift+Z)`}
        </TooltipContent>
      </Tooltip>
    </>
  );
}
